<div id="orCircadianCurves">
  @if (building$ | async; as buildingInfo) {
    <div class="or-content">
      <app-circadian-curve-list [building]="buildingInfo"></app-circadian-curve-list>
    </div>
  }
</div>
